module.exports = __webpack_public_path__ + "media/images/products/retailers-og-6-ec1afe7eead5ffe55bdbb0528c6ca57b.jpg";